// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}


export function FormatTimes(times, pattern) {
  var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss");
  if (pattern) {
    d = new Date(times).Format(pattern);
  }
  return d.toLocaleString();
}

/**
 * 毫秒 转换为时分秒 多则往时上加
 * @param {毫秒} mss 
 */
export function formatDuring(mss) {
  var time = mss;
  var min = Math.floor(time % 3600);
  var hours = Math.floor(time / 3600); //时
  var minutes = Math.floor(min / 60); //分
  var seconds = Math.floor(time % 60); //秒
  //  + "时" + Math.floor(min/60) + "分"+ time%60 + "秒";

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  var result = hours + ":" + minutes + ":" + seconds;

  return result
}

// 秒转时间
export function secondToDate(msd) {
  if (msd == null || msd == undefined || msd == 0) {
    return '--'
  }
  var time = msd
  if (null != time && '' != time) {
    if (time > 60 && time < 60 * 60) {
      time =
        parseInt(time / 60.0) +
        '分' +
        parseInt(
          (parseFloat(time / 60.0) - parseInt(time / 60.0)) *
          60
        ) +
        '秒'
    } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
      time =
        parseInt(time / 3600.0) +
        '时' +
        parseInt(
          (parseFloat(time / 3600.0) -
            parseInt(time / 3600.0)) *
          60
        ) +
        '分' +
        parseInt(
          (parseFloat(
              (parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) *
              60
            ) -
            parseInt(
              (parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) *
              60
            )) *
          60
        ) +
        '秒'
    } else if (time >= 60 * 60 * 24) {
      time =
        parseInt(time / 3600.0 / 24) +
        '天' +
        parseInt(
          (parseFloat(time / 3600.0 / 24) -
            parseInt(time / 3600.0 / 24)) *
          24
        ) +
        '小时' +
        parseInt(
          (parseFloat(time / 3600.0) -
            parseInt(time / 3600.0)) *
          60
        ) +
        '分' +
        parseInt(
          (parseFloat(
              (parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) *
              60
            ) -
            parseInt(
              (parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) *
              60
            )) *
          60
        ) +
        '秒'
    } else {
      time = parseInt(time) + '秒'
    }
  }

  return time
}



// WEBPACK FOOTER //
// ./src/utils/FormatTime.js